<template>
  <div class="custom-report-drawer">
    <el-drawer
      title="自定义报表"
      :visible.sync="visible"
      direction="ttb"
      :modal="true"
      size="auto"
      custom-class="report-drawer"
      :before-close="handleClose"
    >
      <div class="drawer-content">
        <!-- 1. 时间范围选择、空间和设备在一行 -->
        <div class="form-row-container horizontal-fields">
          <div class="form-field-group">
            <div class="label-container">时间范围：</div>
            <div class="content-container">
              <el-date-picker
                v-model="formData.dateRange"
                type="datetimerange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="mini"
                style="width: 100%"
              ></el-date-picker>
            </div>
          </div>

          <div class="form-field-group">
            <div class="label-container">选择空间：</div>
            <div class="content-container">
              <el-cascader
                v-model="formData.spaceIds"
                :options="spaceTree"
                change-on-select
                clearable
                placeholder="请选择空间"
                size="mini"
                style="width: 100%"
                @change="handleSpaceChange"
              ></el-cascader>
            </div>
          </div>
 
          <div class="form-field-group">
            <div class="label-container">选择设备：</div>
            <div class="content-container">
              <el-select
                v-model="formData.deviceIds"
                collapse-tags
                multiple
                placeholder="请选择设备"
                size="mini"
                style="width: 100%"
                filterable
                @change="handleDeviceSelectChange"
              >
                <el-option v-if="deviceOptions.length > 0" value="all" label="全选">
                  <el-checkbox 
                    v-model="isAllDevicesSelected"
                    :indeterminate="isDevicesIndeterminate" 
                    @change="checkAllDevices" 
                    @click.native.stop
                    class="checkbox-label"
                    label="全选">
                  </el-checkbox>
                </el-option>
                <el-option
                  v-for="item in deviceOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>

        <!-- 2. 测点选择单独一行 -->
        <div class="form-row-container">
          <div class="label-container">选择测点：</div>
          <div class="content-container">
            <el-select
              v-model="formData.pointCodes"
              placeholder="请选择测点"
              size="mini"
              style="width: 100%"
              multiple
              collapse-tags
              filterable
              @change="handlePointSelectChange"
            >
              <el-option v-if="pointOptions.length > 0" value="all" label="全选">
                <el-checkbox 
                  v-model="isAllPointsSelected"
                  :indeterminate="isPointsIndeterminate" 
                  @change="checkAllPoints" 
                  @click.native.stop
                  class="checkbox-label"
                  label="全选">
                </el-checkbox>
              </el-option>
              <el-option
                v-for="item in pointOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>

        <!-- 3. 粒度设置区域 -->
        <div class="form-row-container">
          <div class="label-container">选择刻度：</div>
          <div class="content-container radio-group">
            <el-radio-group v-model="formData.timeScale" size="mini">
              <el-radio label="">全量</el-radio>
              <el-radio label="min5">5分钟</el-radio>
              <el-radio label="min10">10分钟</el-radio>
              <el-radio label="min15">15分钟</el-radio>
              <el-radio label="min20">20分钟</el-radio>
              <el-radio label="min25">25分钟</el-radio>
              <el-radio label="min30">30分钟</el-radio>
              <el-radio label="hour">小时</el-radio>
              <el-radio label="day">日</el-radio>
              <el-radio label="month">月</el-radio>
            </el-radio-group>
          </div>
        </div>

        <!-- 4. 测点筛选配置区 -->
        <div class="form-row-container">
          <div class="label-container" style="align-items: flex-start;">测点选择：</div>
          <div class="content-container" style="max-height: 300px; overflow-y: auto;">
            <div class="measure-point-row">
              <div
                v-for="(item, index) in calculateRows"
                :key="index"
                class="measure-point-row"
              >
                <div class="measure-point-header horizontal-measure-row"   style="align-items: flex-start;">
                  <div class="measure-point-field-horizontal cover-field" >
                    <el-checkbox v-model="item.isCover" size="mini">覆盖</el-checkbox>
                  </div>
                  <div class="measure-point-field-horizontal">
                    <span class="sub-label">测点：</span>
                    <div class="point-select-group">
                      <el-select
                        v-model="item.pointId"
                        placeholder="请选择测点"
                        size="mini"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="option in pointOptions"
                          :key="option.value"
                          :label="option.label"
                          :value="option.value"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="operate-list" v-if="item.rowOperates && item.rowOperates.length > 0">
                  <div 
                    v-for="(operate, operateIndex) in item.rowOperates" 
                    :key="'op-'+index+'-'+operateIndex" 
                    class="operate-item"
                    :style="{'padding-top': operateIndex === 0 ? '0px' : '10px'}"
                  >
                    <div class="operate-row">
                      <div class="operate-content operate-btn-group">
                        <div class="btn-group">
                          <img
                            :src="operate.operator === '+' ? require('@/assets/images/historical_data/add_active.png') : require('@/assets/images/historical_data/add.png')"
                            @click="setCalcOperation(index, operateIndex, '+')"
                            class="operation-img"
                          />
                          <img
                            :src="operate.operator === '-' ? require('@/assets/images/historical_data/subtract_active.png') : require('@/assets/images/historical_data/subtract.png')"
                            @click="setCalcOperation(index, operateIndex, '-')"
                            class="operation-img"
                          />
                          <img
                            :src="operate.operator === '*' ? require('@/assets/images/historical_data/multiply_active.png') : require('@/assets/images/historical_data/multiply.png')"
                            @click="setCalcOperation(index, operateIndex, '*')"
                            class="operation-img"
                          />
                          <img
                            :src="operate.operator === '/' ? require('@/assets/images/historical_data/divide_active.png') : require('@/assets/images/historical_data/divide.png')"
                            @click="setCalcOperation(index, operateIndex, '/')"
                            class="operation-img"
                          />
                        </div>
                      </div>
                      <div class="operate-content value-switch-group">
                        <div class="value-switch">
                          <el-checkbox v-model="operate.isPoint" size="mini" style="margin-right: 10px;">测点</el-checkbox>
                          <el-select 
                            v-if="operate.isPoint" 
                            v-model="operate.pointId" 
                            placeholder="请选择测点" 
                            size="mini" 
                            style="width: 100%"
                            @change="updateCalcPointName(index, operateIndex)">
                            <el-option v-for="option in pointOptions" :key="option.value" :label="option.label"
                              :value="option.value">
                            </el-option>
                          </el-select>
                          <el-input 
                            v-else 
                            v-model.number="operate.value" 
                            placeholder="请输入数值" 
                            size="mini" 
                            type="number">
                          </el-input>
                        </div>
                      </div>
                      <div class="operate-actions" v-if="item.rowOperates.length > 1">
                        <el-button 
                          type="text" 
                          icon="el-icon-delete" 
                          size="mini" 
                          @click="deleteRowOperate(index, operateIndex)" 
                          class="delete-btn"
                        ></el-button>
                      </div>
                    </div>
                  </div>
                </div>
                  <div class="row-actions">
                    <el-button type="text" size="mini" @click="addRowOperate(index)" class="add-btn">新增运算</el-button>
                    <el-button type="text" size="mini" @click="addCalcOperation" class="add-btn">新增一条</el-button>
                    <el-button
                      v-if="calculateRows.length > 1"
                      type="text"
                      icon="el-icon-delete"
                      size="mini"
                      @click="deleteMeasurePoint(index)"
                      class="delete-btn"
                    >删除</el-button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <!-- 5. 值类型选择 -->
        <div class="form-row-container">
          <div class="label-container">值类型：</div>
          <div class="content-container checkbox-group">
            <el-checkbox v-model="all" @change="allChange" size="mini" :disabled="isAllValueDisabled">全量值</el-checkbox>
            <el-checkbox v-model="formData.valueType.actual" @change="valueTypeChange" size="mini">最新值</el-checkbox>
            <el-checkbox v-model="formData.valueType.average" @change="valueTypeChange" size="mini">平均值</el-checkbox>
            <el-checkbox v-model="formData.valueType.max" @change="valueTypeChange" size="mini">最大值</el-checkbox>
            <el-checkbox v-model="formData.valueType.min" @change="valueTypeChange" size="mini">最小值</el-checkbox>
          </div>
        </div>

        <!-- 6. 输出形式选择 -->
        <div class="form-row-container">
          <div class="label-container">输出：</div>
          <div class="content-container checkbox-group">
            <el-checkbox v-model="formData.output.excel" size="mini">表格</el-checkbox>
            <el-checkbox v-model="formData.output.line" size="mini">曲线</el-checkbox>
            <el-checkbox v-model="formData.output.bar" size="mini">柱状图</el-checkbox>
            <el-checkbox v-model="formData.output.pie" size="mini">饼图</el-checkbox>
          </div>
        </div>

        <!-- 底部按钮区域 -->
        <div class="drawer-footer">
          <el-button @click="handleClose" size="mini">取消</el-button>
          <el-button type="primary" class="export-btn" @click="handleSubmit" size="mini">导出</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getSpaceTreeData, getTreeHaveDisabled } from "@/network/space-info";
import { userDevice } from "@/network/device-info";
import { listByDeviceIdList } from "@/network/device-measuring-point";
import { exportCustomReport } from "@/network/measuring-point-history";

export default {
  name: "CustomReportDialig",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initialData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    // 获取今天的开始时间和结束时间
    const today = new Date();
    const startOfToday = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
      0,
      0,
      0
    );
    const endOfToday = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
      23,
      59,
      59
    );

    return {
      all: '',
      formData: {
        dateRange: [startOfToday, endOfToday],
        pointCodes: [],
        timeScale: "", 
        valueType: {
          actual: false,
          average: false,
          max: false,
          min: false
        },
        output: {
          excel: true, // 默认选中表格
          line: false, // 
          bar: false,
          pie: false
        },
        deviceIds: [], // 修改为数组形式
      },
      calculateRows: [
        {
          pointId: "",
          isCover: false,
          rowOperates: [
            {
              operator: "+",
              isPoint: false,
              pointId: "",
              pointName: "",
              value: ""
            }
          ]
        }
      ],
      spaceTree: [],
      deviceOptions: [],
      pointOptions: [],
      isAllDevicesSelected: false,
      isDevicesIndeterminate: false,
      isAllPointsSelected: false,
      isPointsIndeterminate: false
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        if (!val) {
          setTimeout(() => {
            this.resetFormData();
          }, 300);
        }
      }
    },
    // 新增计算属性：判断全量值选项是否应该被禁用
    isAllValueDisabled() {
      // 当时间刻度不是空字符串时，表示不是全量时间刻度，此时应禁用全量值选项
      return this.formData.timeScale !== "";
    }
  },
  watch: {
    initialData: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.formData = { ...this.formData, ...newVal };
        }
      },
      immediate: true,
      deep: true
    },
    "formData.space": {
      handler(val) {
        if (val) {
          this.getDevicesBySpace(val);
        } else {
          this.deviceOptions = [];
          this.formData.deviceIds = []; // 修改为数组
          this.pointOptions = [];
          this.formData.pointCodes = [];
        }
      }
    },
    "formData.deviceIds": {
      handler(val) {
        if (!val) return;
        const checkedCount = val.length;
        this.isAllDevicesSelected = checkedCount === this.deviceOptions.length && this.deviceOptions.length > 0;
        this.isDevicesIndeterminate = checkedCount > 0 && checkedCount < this.deviceOptions.length;
      },
      deep: true
    },
    deviceOptions: {
      handler() {
        if (!this.formData.deviceIds) return;
        const checkedCount = this.formData.deviceIds.length;
        this.isAllDevicesSelected = checkedCount === this.deviceOptions.length && this.deviceOptions.length > 0;
        this.isDevicesIndeterminate = checkedCount > 0 && checkedCount < this.deviceOptions.length;
      },
      deep: true
    },
    "formData.pointCodes": {
      handler(val) {
        if (!val) return;
        const checkedCount = val.length;
        this.isAllPointsSelected = checkedCount === this.pointOptions.length && this.pointOptions.length > 0;
        this.isPointsIndeterminate = checkedCount > 0 && checkedCount < this.pointOptions.length;
      },
      deep: true
    },
    pointOptions: {
      handler() {
        if (!this.formData.pointCodes) return;
        const checkedCount = this.formData.pointCodes.length;
        this.isAllPointsSelected = checkedCount === this.pointOptions.length && this.pointOptions.length > 0;
        this.isPointsIndeterminate = checkedCount > 0 && checkedCount < this.pointOptions.length;
      },
      deep: true
    },
    value(newVal) {
      if (newVal) {
        this.resetFormData();
      }
    },
    'formData.valueType': {
      handler(val) {
        if (val.actual || val.average || val.max || val.min) {
          this.all = false;
        }
      },
      deep: true
    },
    "formData.timeScale": {
      handler(val) {
        // 当时间刻度从全量变为非全量时，如果全量值被选中，则自动取消选中
        if (val !== "" && this.all) {
          this.all = false;
        }
      }
    }
  },
  created() {
    this.getSpaceTreeData();
  },
  methods: {
    getSpaceTreeData() {
      getSpaceTreeData().then(res => {
        if (res.code === 0) {
          this.spaceTree = getTreeHaveDisabled(res.data);
        }
      });
    },
    getDevicesBySpace(spaceId) {
      userDevice(spaceId).then(res => {
        if (res.code === 0) {
          let result = [];
          let obj = {};
          for (var i = 0; i < res.data.length; i++) {
            if (!obj[res.data[i].name]) {
              const device = res.data[i];
              result.push({
                value: device.id,
                label: device.name
              });
              obj[device.name] = true;
            }
          }
          this.deviceOptions = result;

          if (
            this.formData.deviceIds &&
            !this.deviceOptions.some(opt => opt.value === this.formData.deviceIds[0])
          ) {
            this.formData.deviceIds = [];
          }
        }
      });
    },
    getPointsByDevice(deviceIds) {
      // if (!deviceIds || deviceIds.length === 0) return;

      listByDeviceIdList(deviceIds).then(res => {
        if (res.code === 0) {
          this.pointOptions = res.data.map(point => ({
            value: point.id,
            label: point.name
          }));

          if (this.formData.pointCodes && this.formData.pointCodes.length > 0) {
            this.formData.pointCodes = this.formData.pointCodes.filter(id =>
              this.pointOptions.some(opt => opt.value === id)
            );
          }
        }
      });
    },
    handleSpaceChange(value) {
      if (Array.isArray(value) && value.length > 0) {
        this.formData.space = value[value.length - 1];
      } else {
        this.formData.space = value;
      }
    },
    resetSelections() {
      this.formData.space = "";
      this.formData.deviceIds = []; // 修改为数组
      this.formData.pointCodes = [];
      this.deviceOptions = [];
      this.pointOptions = [];
    },
    handleClose() {
      this.$emit("input", false);
      this.$emit("cancel");
    },
    addMeasurePoint() {
      this.calculateRows.push({
        pointId: "",
        isCover: false,
        rowOperates: [
          {
            operator: "",
            isPoint: false,
            pointId: "",
            pointName: "",
            value: ""
          }
        ]
      });
    },
    deleteMeasurePoint(index) {
      if (this.calculateRows.length > 1) {
        this.calculateRows.splice(index, 1);
      }
    },
    setOperation(index, operateIndex, operation) {
      const operate = this.calculateRows[index].rowOperates[operateIndex];
      if (operate.operator === operation) {
        operate.operator = "";
      } else {
        operate.operator = operation;
      }
    },
    handleSubmit() {
      if (!this.validateForm()) {
        return;
      }

      const exportParams = this.buildExportParams();

      this.$message.info("报表生成中，请稍候...");

      exportCustomReport(exportParams)
        .then(res => {
          if (res.code === 0) {
            this.$message.success("报表已生成，请在下载列表中查看");
          }
        })
        .catch(err => {
          console.error("导出报表错误:", err);
          this.$message.error("报表生成失败，请稍后重试");
        })
        .finally(() => {
          this.$emit("input", false);
        });
    },
    validateForm() {
      if (!this.formData.dateRange || this.formData.dateRange.length !== 2) {
        this.$message.warning("请选择时间范围");
        return false;
      }

      if (!this.formData.space) {
        this.$message.warning("请选择空间");
        return false;
      }

      if (!this.formData.deviceIds || this.formData.deviceIds.length === 0) {
        this.$message.warning("请选择设备");
        return false;
      }

      // 检查输出方式
      const hasOutput = Object.values(this.formData.output).some(val => val);
      if (!hasOutput) {
        this.$message.warning("请至少选择一种输出方式");
        return false;
      }

      // 检查是否选择了值类型或全量值
      const hasValueType = this.all || Object.values(this.formData.valueType).some(val => val);
      if (!hasValueType) {
        this.$message.warning("请至少选择一种值类型");
        return false;
      }

      // 验证计算行是否配置正确
      for (let i = 0; i < this.calculateRows.length; i++) {
        const row = this.calculateRows[i];
        
        // 如果勾选了覆盖，则测点必选
        if (row.isCover && !row.pointId) {
          this.$message.warning(`第${i + 1}行勾选了覆盖，请选择基础测点`);
          return false;
        }
        
        // 如果选择了测点，检查运算操作
        if (row.pointId) {
          // 检查每个运算操作是否有效
          for (let j = 0; j < row.rowOperates.length; j++) {
            const op = row.rowOperates[j];
            
            if (!op.operator) {
              this.$message.warning(`第${i + 1}行第${j + 1}个运算未选择运算符`);
              return false;
            }
            
            if (op.isPoint && !op.pointId) {
              this.$message.warning(`第${i + 1}行第${j + 1}个运算选择了测点，但未指定具体测点`);
              return false;
            }
            
            if (!op.isPoint && (op.value === null || op.value === undefined || op.value === "")) {
              this.$message.warning(`第${i + 1}行第${j + 1}个运算未输入数值`);
              return false;
            }
          }
        }
        
        // 如果勾选了覆盖，确保所有运算操作都已正确配置
        if (row.isCover) {
          for (let j = 0; j < row.rowOperates.length; j++) {
            const op = row.rowOperates[j];
            
            if (!op.operator) {
              this.$message.warning(`第${i + 1}行勾选了覆盖，第${j + 1}个运算未选择运算符`);
              return false;
            }
            
            if (op.isPoint && !op.pointId) {
              this.$message.warning(`第${i + 1}行勾选了覆盖，第${j + 1}个运算选择了测点，但未指定具体测点`);
              return false;
            }
            
            if (!op.isPoint && (op.value === null || op.value === undefined || op.value === "")) {
              this.$message.warning(`第${i + 1}行勾选了覆盖，第${j + 1}个运算未输入数值`);
              return false;
            }
          }
        }
      }

      return true;
    },
    buildExportParams() {
      const startTime =
        this.formData.dateRange[0] instanceof Date
          ? this.formatDate(this.formData.dateRange[0])
          : this.formData.dateRange[0];

      const endTime =
        this.formData.dateRange[1] instanceof Date
          ? this.formatDate(this.formData.dateRange[1])
          : this.formData.dateRange[1];

      const { scaleUnit, scaleNum } = this.getTimeScale();

      let valueTypes = [];
      let valueFields = [];

      if (this.all) {
        valueTypes = [];
        valueFields = [];
      } else {
        if (this.formData.valueType.actual) {
          valueTypes.push("实时值");
          valueFields.push("pointValueRealTime");
        }

        if (this.formData.valueType.average) {
          valueTypes.push("平均值");
          valueFields.push("pointValueAvg");
        }

        if (this.formData.valueType.max) {
          valueTypes.push("最大值");
          valueFields.push("pointValueMax");
        }

        if (this.formData.valueType.min) {
          valueTypes.push("最小值");
          valueFields.push("pointValueMin");
        }
      }

      const outputTypes = [];

      if (this.formData.output.excel) outputTypes.push("excel");
      if (this.formData.output.line) outputTypes.push("line");
      if (this.formData.output.bar) outputTypes.push("bar");
      if (this.formData.output.pie) outputTypes.push("pie");

      // 处理calculateRows，确保结构符合API文档要求
      const formattedCalcRows = this.calculateRows.map(row => {
        // 处理每个操作项的值和测点ID
        const formattedOperates = row.rowOperates.map(op => {
          return {
            operator: op.operator,
            isPoint: op.isPoint,
            pointId: op.isPoint ? op.pointId : 0,
            pointName: op.isPoint ? (this.getPointNameById(op.pointId) || "") : "",
            value: op.isPoint ? "" : (op.value || "")
          };
        });
        
        return {
          pointId: row.pointId || 0,
          isCover: row.isCover || false,
          rowOperates: formattedOperates
        };
      });

      return {
        startTime,
        endTime,
        spaceId: this.formData.space,
        deviceIds: this.formData.deviceIds, // 直接传递设备ID数组
        pointIds: this.formData.pointCodes,
        scaleUnit,
        scaleNum,
        valueTypes,
        titleFields: [],
        valueFields,
        calculateRows: formattedCalcRows,
        outputTypes
      };
    },
    mapOperationToOperator(operation) {
      const map = {
        add: "+",
        subtract: "-",
        multiply: "*",
        divide: "/"
      };
      return map[operation] || operation;
    },
    getTimeScale() {
      const scaleMap = {
        min5: { scaleUnit: "minute", scaleNum: 5 },
        min10: { scaleUnit: "minute", scaleNum: 10 },
        min15: { scaleUnit: "minute", scaleNum: 15 },
        min20: { scaleUnit: "minute", scaleNum: 20 },
        min25: { scaleUnit: "minute", scaleNum: 25 },
        min30: { scaleUnit: "minute", scaleNum: 30 },
        hour: { scaleUnit: "hour", scaleNum: 1 },
        day: { scaleUnit: "day", scaleNum: 1 },
        month: { scaleUnit: "month", scaleNum: 1 }
      };

      return (
        scaleMap[this.formData.timeScale] || {
          scaleUnit: "",
          scaleNum: ""
        }
      );
    },
    formatDate(date) {
      if (!date) return "";

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    resetFormData() {
      const today = new Date();
      const startOfToday = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        0,
        0,
        0
      );
      const endOfToday = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        23,
        59,
        59
      );

      this.formData = {
        dateRange: [startOfToday, endOfToday],
        pointCodes: [],
        spaceIds: [],
        space: "",
        deviceIds: [], // 修改为数组
        timeScale: "",
        valueType: {
          actual: false,
          average: false,
          max: false,
          min: false
        },
        output: {
          excel: true,
          line: false,
          bar: false,
          pie: false
        }
      };

      this.calculateRows = [
        {
          pointId: "",
          isCover: false,
          rowOperates: [
            {
              operator: "+",
              isPoint: false,
              pointId: "",
              pointName: "",
              value: ""
            }
          ]
        }
      ];

      this.deviceOptions = [];
      this.pointOptions = [];
      this.isAllDevicesSelected = false;
      this.isDevicesIndeterminate = false;
      this.isAllPointsSelected = false;
      this.isPointsIndeterminate = false;
      this.all = false;
    },
    updatePointName(index) {
      const point = this.calculateRows[index];
      if (point.isPoint && point.pointId) {
        const selectedPoint = this.pointOptions.find(
          p => p.value === point.pointId
        );
        if (selectedPoint) {
          point.pointName = selectedPoint.label;
        }
      }
    },
    addCalcOperation() {
      this.calculateRows.push({
        pointId: "",
        isCover: false,
        rowOperates: [
          {
            operator: "+",
            isPoint: false,
            pointId: null,
            pointName: "",
            value: ""
          }
        ]
      });
    },
    deleteCalcOperation(index) {
      this.calculateRows.splice(index, 1);
    },
    updateCalcPointName(rowIndex, opIndex) {
      const op = this.calculateRows[rowIndex].rowOperates[opIndex];
      if (op.isPoint && op.pointId) {
        const point = this.pointOptions.find(p => p.value === op.pointId);
        if (point) {
          op.pointName = point.label;
        }
      }
    },
    setCalcOperation(calcIndex, opIndex, operator) {
      // 设置当前运算行的运算符
      this.calculateRows[calcIndex].rowOperates[opIndex].operator = operator;
    },
    addRowOperate(index) {
      if (this.calculateRows[index]) {
        this.calculateRows[index].rowOperates.push({
          operator: "+", // 默认使用加号
          isPoint: false,
          pointId: null,
          pointName: "",
          value: ""
        });
      }
    },
    deleteRowOperate(rowIndex, opIndex) {
      if (this.calculateRows[rowIndex] && this.calculateRows[rowIndex].rowOperates.length > 1) {
        this.calculateRows[rowIndex].rowOperates.splice(opIndex, 1);
      }
    },
    // 新增辅助方法，根据ID获取测点名称
    getPointNameById(id) {
      if (!id) return "";
      const point = this.pointOptions.find(p => p.value === id);
      return point ? point.label : "";
    },
    checkAllDevices(val) {
      this.isDevicesIndeterminate = false;
      if (val) {
        this.formData.deviceIds = this.deviceOptions.map(item => item.value);
      } else {
        this.formData.deviceIds = [];
      }
      // 更新测点列表
      this.getPointsByDevice(this.formData.deviceIds);
    },
    handleDeviceSelectChange(val) {
      // 检查是否选择了全选选项
      const allOptionIndex = val.indexOf('all');
      if (allOptionIndex > -1) {
        // 移除全选选项
        val.splice(allOptionIndex, 1);
        
        // 根据当前全选状态切换
        if (!this.isAllDevicesSelected) {
          // 如果当前不是全选，则全选
          this.isAllDevicesSelected = true;
          this.isDevicesIndeterminate = false;
          this.formData.deviceIds = this.deviceOptions.map(item => item.value);
        } else {
          // 如果当前是全选，则取消全选
          this.isAllDevicesSelected = false;
          this.isDevicesIndeterminate = false;
          this.formData.deviceIds = [];
        }
      } else {
        // 正常更新选中值
        this.formData.deviceIds = val;
      }
      
      // 更新测点列表
      this.getPointsByDevice(this.formData.deviceIds);
    },
    checkAllPoints(val) {
      this.isPointsIndeterminate = false;
      if (val) {
        this.formData.pointCodes = this.pointOptions.map(item => item.value);
      } else {
        this.formData.pointCodes = [];
      }
    },
    handlePointSelectChange(val) {
      // 检查是否选择了全选选项
      const allOptionIndex = val.indexOf('all');
      if (allOptionIndex > -1) {
        // 移除全选选项
        val.splice(allOptionIndex, 1);
        
        // 根据当前全选状态切换
        if (!this.isAllPointsSelected) {
          // 如果当前不是全选，则全选
          this.isAllPointsSelected = true;
          this.isPointsIndeterminate = false;
          this.formData.pointCodes = this.pointOptions.map(item => item.value);
        } else {
          // 如果当前是全选，则取消全选
          this.isAllPointsSelected = false;
          this.isPointsIndeterminate = false;
          this.formData.pointCodes = [];
        }
      } else {
        // 正常更新选中值
        this.formData.pointCodes = val;
      }
    },
    allChange(val) {
      if (val) {
        // 如果选中了全量值，其他值类型都设为false
        this.formData.valueType.actual = false;
        this.formData.valueType.average = false;
        this.formData.valueType.max = false;
        this.formData.valueType.min = false;
      }
    },
    valueTypeChange() {
      // 如果有任何一个值类型被选中，则取消全量值
      if (this.formData.valueType.actual || 
          this.formData.valueType.average || 
          this.formData.valueType.max || 
          this.formData.valueType.min) {
        this.all = false;
      }
    }
  }
};
</script>

<style scoped>
.report-drawer {
  background-color: transparent !important;
  /* 透明背景 */
}

.drawer-content {
  padding: 15px 20px;
  background-color: rgba(4, 22, 38, 0.95);
  /* 深蓝色背景 */
  height: 100%;
  overflow-y: auto;
}

.section-title {
  color: #fff;
  font-size: 14px;
  margin: 15px 0 8px 0;
  border-top: 1px solid rgba(41, 155, 255, 0.2);
  padding-top: 15px;
}

.section-title-inline {
  color: #fff;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 15px;
}

.section-title:first-child {
  border-top: none;
  padding-top: 0;
  margin-top: 0;
}

.form-row {
  margin-bottom: 15px;
  align-items: center;
}

.field-label {
  color: rgba(255, 255, 255, 0.8);
  font-size: 13px;
  margin-bottom: 5px;
}

.checkbox-group {
  display: flex;
  flex-wrap: wrap;
}

.checkbox-group .el-checkbox {
  margin-right: 15px;
  margin-bottom: 5px;
}

.measure-point-row {
  background-color: rgba(13, 36, 56, 0.3);
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
}

.measure-point-header {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.point-select-group {
  display: flex;
  align-items: center;
}

.cover-checkbox {
  margin-left: 8px;
  margin-top: 0;
}

.operation-buttons {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.btn-group {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.btn-group .el-button {
  padding: 5px;
  margin: 0 2px;
}

.active-operation {
  border: 2px solid #fff !important;
  box-shadow: 0 0 5px rgba(255, 255, 255, 0.5);
}

.add-new-link {
  display: none;
}

.drawer-footer {
  position: sticky;
  bottom: 0;
  right: 0;
  left: 0;
  padding: 15px 0;
  background: rgba(4, 22, 38, 0.95);
  text-align: right;
  border-top: 1px solid rgba(41, 155, 255, 0.2);
  margin-top: 20px;
}

/* Element UI组件样式覆盖 */
::v-deep .el-drawer__header {
  color: #ffffff;
  margin-bottom: 0;
  padding: 15px 20px;
  border-bottom: 1px solid rgba(41, 155, 255, 0.2);
  background-color: rgba(4, 22, 38, 0.95);
  font-size: 16px;
}

::v-deep .el-drawer {
  background-color: transparent !important;
}

::v-deep .el-checkbox__label {
  color: #ffffff;
  font-size: 13px;
}

::v-deep .el-select .el-input__inner,
::v-deep .el-input .el-input__inner,
::v-deep .el-date-editor--datetimerange.el-input__inner {
  background-color: rgba(13, 36, 56, 0.8);
  border: 1px solid rgba(41, 155, 255, 0.3);
  color: white;
}

::v-deep .el-date-editor .el-range-separator {
  color: rgba(255, 255, 255, 0.7);
}

::v-deep .el-date-editor .el-range-input {
  color: white;
  background-color: transparent;
}

::v-deep .el-drawer__body {
  overflow-y: auto;
  padding: 0;
}

::v-deep .el-button--primary {
  background-color: rgba(41, 155, 255, 0.6);
  border-color: rgba(41, 155, 255, 0.8);
}

::v-deep .el-button--primary:hover {
  background-color: rgba(41, 155, 255, 0.8);
  border-color: rgba(41, 155, 255, 1);
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #409eff;
  border-color: #409eff;
}

.operation-img {
  width: 24px;
  height: 24px;
  cursor: pointer;
  margin: 0 2px;
}

.label-inline {
  color: #fff;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;
  white-space: nowrap;
}

.form-row {
  margin-bottom: 15px;
  align-items: center;
}

.point-select-group {
  display: flex;
  align-items: center;
}

.cover-checkbox {
  margin-left: 4px;
  margin-right: 0;
  white-space: nowrap;
}

.form-row-container {
  display: flex;
  margin-bottom: 15px;
  border-bottom: 1px solid rgba(41, 155, 255, 0.1);
  padding-bottom: 10px;
}

.form-row-container:last-child {
  border-bottom: none;
}

.label-container {
  width: 100px;
  color: #fff;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
}

.content-container {
  flex: 1;
  padding-left: 5px;
}

.measure-point-field {
  display: flex;
  margin-bottom: 10px;
  align-items: center;
}

.sub-label {
  width: 70px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 13px;
  text-align: right;
  padding-right: 10px;
}

.point-select-group {
  display: flex;
  align-items: center;
  flex: 1;
}

.btn-group {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.inline-inputs {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.inline-input-item {
  display: flex;
  align-items: center;
}

.inline-label {
  color: rgba(255, 255, 255, 0.8);
  font-size: 13px;
  white-space: nowrap;
  margin-right: 10px;
}

/* 新增的样式: 水平布局的字段容器 */
.horizontal-fields {
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
}

.form-field-group {
  display: flex;
  flex: 1;
  min-width: 300px;
}

/* 新增横向布局的测点行 */
.horizontal-measure-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.measure-point-field-horizontal {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 200px;
  margin-bottom: 0;
}

.cover-field {
  flex: 0.1;
  min-width: 100px;
}

.operation-field {
  flex: 0.5;
  min-width: 150px;
}

.value-field {
  flex: 0.5;
  min-width: 150px;
}

/* 行内操作按钮 */
.row-actions {
  display: flex;
  align-items: center;
  margin-left: 10px;
}

.delete-btn {
  color: #f56c6c !important;
  padding: 0 5px;
}

.add-btn {
  color: #409eff !important;
  padding: 0 5px;
}

.export-btn {
  background-color: rgba(41, 159, 251, 0.6) !important;
  border-color: rgba(41, 159, 251, 0.6) !important;
}

.value-switch {
  display: flex;
  align-items: center;
  width: 100%;
}

/* 新增运算行样式 */
.calc-row {
  background-color: rgba(13, 46, 76, 0.4);
  border-left: 3px solid #409eff;
  margin-top: 10px;
}

/* 运算操作列表样式 */
.operate-list {
  padding-left: 15px;
}

.operate-item {
  margin-bottom: 10px;
  padding: 8px;
  background-color: rgba(13, 36, 56, 0.2);
  border-radius: 4px;
}

.operate-row {
  display: flex;
  align-items: center;
}

.operate-content {
  margin-right: 30px;
}

.operate-btn-group {
  width: 120px;
  flex-shrink: 0;
}

.value-switch-group {
  flex: 1;
}

.operate-actions {
  width: 40px;
  display: flex;
  justify-content: flex-end;
}

/* 确保运算符按钮组样式正确 */
.btn-group {
  display: flex;
  justify-content: space-between;
  max-width: 120px;
}

/* 确保按钮样式正确 */
.row-actions {
  display: flex;
  align-items: center;
}

.delete-btn {
  color: #f56c6c !important;
  padding: 0 5px;
}

.add-btn {
  color: #409eff !important;
  padding: 0 5px;
}

.checkbox-label ::v-deep .el-checkbox__label{
  color: #606266 !important;
}
</style>
